
export const Path = {
    getUserName: '/nth/utilities/api/authenticate/app-config-system/{key}',
    getAllWish: '/nth/utilities/api/authenticate/app-config-system-lst/{unit}',
    saveWish: '/nth/utilities/api/authenticate/app-config-system',
}